module.exports = __webpack_public_path__ + "img/6be0722.jpg";